import * as React from "react";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import { Image as ImageDialog } from "../../components/Dialog";
import FallBackImage from "../../components/FallBackImage";
import { useModalState } from "../../hooks";
import { getImageUrl } from "../../utils/images";
import DeliveryImagesCarousel from "./DeliveryImagesCarousel";
import { useEnvContext } from "../../env";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  img: {
    [breakpoints.down("xs")]: {
      maxHeight: typography.pxToRem(153),
      maxWidth: typography.pxToRem(153)
    },
    [breakpoints.up("sm")]: {
      maxHeight: typography.pxToRem(140),
      maxWidth: typography.pxToRem(140)
    }
  },
  imageContainer: {
    paddingTop: typography.pxToRem(41)
  },
  carouselImageContainer: {
    width: typography.pxToRem(253),
    display: "block",
    [breakpoints.down("xs")]: {
      width: typography.pxToRem(153)
    }
  },
  wrapper: {
    display: "flex",
    border: `${typography.pxToRem(1)} solid ${palette.border.iconBlock}`,
    position: "relative",
    minWidth: typography.pxToRem(50),
    minHeight: typography.pxToRem(50),
    [breakpoints.down("xs")]: {
      marginLeft: typography.pxToRem(6),
      marginRight: typography.pxToRem(6)
    },
    [breakpoints.up("sm")]: {
      marginLeft: typography.pxToRem(7.5),
      marginRight: typography.pxToRem(7.5)
    }
  },
  text: {
    paddingTop: typography.pxToRem(13),
    marginBottom: typography.pxToRem(13),
    color: "#1d9ad0",
    fontSize: typography.pxToRem(13),
    letterSpacing: 0.44,
    textAlign: "center",
    fontWeight: 400,
    width: typography.pxToRem(125),
    height: typography.pxToRem(30)
  }
}));

const DeliveryImages = ({
  images,
  containerClassName,
  withCarousel,
  withoutArrows,
  carouselTextClassName,
  entityCode
}) => {
  const [open, show, hide] = useModalState(false);
  const styles = useStyles();
  const [source, setSource] = React.useState("");
  const {
    API_HOST,
    ENTITY_PREFIX
  } = useEnvContext();

  const showFullImage = src => {
    setSource(src);
    show();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "center",
    className: clsx(styles.imageContainer, {
      [styles.carouselImageContainer]: withCarousel
    }, containerClassName)
  }, withCarousel ? /*#__PURE__*/React.createElement(DeliveryImagesCarousel, {
    images: images,
    showFullImage: showFullImage,
    withoutArrows: withoutArrows,
    entityCode: entityCode
  }) : images && images.map(image => {
    const src = getImageUrl(API_HOST, ENTITY_PREFIX, entityCode, image.key, {
      imageType: image.type
    });
    return /*#__PURE__*/React.createElement("div", {
      key: image.key,
      className: styles.wrapper
    }, /*#__PURE__*/React.createElement(FallBackImage, {
      key: image.key + image.type,
      className: styles.img,
      onClick: () => showFullImage(src),
      src: src,
      alt: ""
    }));
  })), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.text, carouselTextClassName)
  }, "Click on image to view larger version"))), /*#__PURE__*/React.createElement(ImageDialog, {
    open: open,
    src: source,
    onClose: hide
  }));
};

export default DeliveryImages;